import React from 'react'

import {
  StyledTreeView,
  type StyledTreeViewProps,
} from '~/components/elements/StyledTreeView'
import { type Brand as BrandBase } from '~/gql/graphql'

type Brand = App.PickGraphQL<BrandBase, 'id' | 'name'>

export type BrandTreeViewProps<TBrand extends Brand> = {
  brands: TBrand[]
  'data-testid'?: string
  onItemClick?: (brandId: TBrand['id']) => void
}

export const BrandTreeView = <TBrand extends Brand>({
  brands,
  'data-testid': dataTestId = 'components-features-brand-tree-view',
  onItemClick,
}: BrandTreeViewProps<TBrand>) => {
  const handleItemClick = React.useCallback<
    EH<StyledTreeViewProps, 'onItemClick'>
  >(
    (event) => {
      const brand: TBrand = event.item
      onItemClick?.(brand.id)
    },
    [onItemClick],
  )

  return (
    <StyledTreeView
      data={brands}
      data-testid={dataTestId}
      textField="name"
      onItemClick={handleItemClick}
    />
  )
}
